var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1953_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C20.0292 0.00659386 15.2639 1.98415 11.749 5.49903C8.23415 9.01391 6.25659 13.7792 6.25 18.75C6.25 32.2109 23.7188 49.0703 24.4609 49.7813C24.6053 49.9216 24.7987 50.0001 25 50.0001C25.2013 50.0001 25.3947 49.9216 25.5391 49.7813C26.2812 49.0703 43.75 32.2109 43.75 18.75C43.7434 13.7792 41.7658 9.01391 38.251 5.49903C34.7361 1.98415 29.9708 0.00659386 25 0Z",
    fill: "#008B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9239 25.2785H27.7652V32.1428H22.2281V25.2785H18.0694C16.992 25.2785 16.3202 23.9401 16.853 22.8668L19.2857 18.0432L23.7803 9.13828C24.3132 8.06491 25.6685 8.06491 26.213 9.13828L30.7076 18.0432L33.1403 22.8668C33.6847 23.9534 33.0128 25.2785 31.9239 25.2785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9522 27.7127C29.8146 27.5419 28.6531 27.4281 27.4556 27.3956C23.5399 27.2736 19.8518 27.916 16.6665 29.1194V29.7618C19.6721 28.7373 23.0969 28.2006 26.6893 28.3144C28.1621 28.3632 29.5871 28.5177 30.9522 28.7616V27.7127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1953_720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.79da23ce26ab308c983c0d7942577489.svg";
export { ForwardRef as ReactComponent };